/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Bc_Company_IdInputs */

const en_reference_field_bc_company_id = /** @type {(inputs: Reference_Field_Bc_Company_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Central company`)
};

/**
* | output |
* | --- |
* | "Business Central company" |
*
* @param {Reference_Field_Bc_Company_IdInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_bc_company_id = /** @type {((inputs?: Reference_Field_Bc_Company_IdInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Bc_Company_IdInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_bc_company_id(inputs)
});